import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AccountsAPI } from "api/axios.config";

const CTO_SWEEP_BASE = "/CTOSweep";
const JSON_HEADERS = { headers: { "Content-Type": "application/json" } };

const getCTOSweepList = (page, limit, parameter, orderby) => {
  let url = `${CTO_SWEEP_BASE}?Page=${page}&Limit=${limit}`;
  if (parameter.billsOnly) {
    url += `&BillsOnly=${parameter.billsOnly}`;
  }
  if (parameter.includeRingfenced) {
    url += `&IncludeRingFenced=${parameter.includeRingfenced}`;
  }
  if (parameter.dpuWithNoVAT) {
    url += `&DPUWithNoVAT=true`;
  }
  if (orderby) {
    url += `&OrderBy=${orderby}`;
  }
  return AccountsAPI.get(url);
};

const postCTOSweep = (data) =>
  AccountsAPI.post(CTO_SWEEP_BASE, JSON.stringify({ data }), JSON_HEADERS);

const buildOrderBy = (sort) => {
  if (!sort) return "matterRef";
  return sort.dir === "desc" ? `${sort.field} desc` : sort.field;
};

const fetchCTOSweep = createAsyncThunk(
  "ctoSweep/fetchList",
  async ({ page, limit, parameter = "", sort }) => {
    const orderby = buildOrderBy(sort);
    const res = await getCTOSweepList(page, limit, parameter, orderby);
    return res.data;
  },
);

const initialState = {
  ctoSweepData: [],
  isLoading: false,
};

const ctoSweepSlice = createSlice({
  name: "ctoSweep",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCTOSweep.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCTOSweep.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ctoSweepData = action.payload || [];
      })
      .addCase(fetchCTOSweep.rejected, (state) => {
        state.isLoading = false;
        state.ctoSweepData = { data: [], total: 0 };
      });
  },
});

const ctoSweepReducer = ctoSweepSlice.reducer;

export { ctoSweepReducer, fetchCTOSweep, postCTOSweep };
